<template>
  <form>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="members">Members</label>
              <div
                class="input-wrapper d-flex mb-2"
                v-for="(addedMember, index) in addedMembers"
                :key="index"
              >
                <input
                  type="text"
                  :value="addedMember"
                  class="form-control"
                  disabled
                />
                <ActionButton
                  label="x"
                  type="button"
                  :theme="{ primary, secondary, event, danger }"
                  class="w-auto py-0 mt-0"
                  @customEvent="handleMemberRemoveClick({ index })"
                />
              </div>
              <div class="input-wrapper d-flex">
                <v-select
                  :options="members"
                  v-model="selectedMember"
                  id="member"
                  placeholder="Choose a member"
                />
                <ActionButton
                  label="+"
                  type="button"
                  :theme="{ primary, secondary, event, danger }"
                  class="w-auto py-0 mt-0"
                  @customEvent="handleAddMemberClick"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group text-right mb-0">
              <ActionButton
                label="Add"
                :theme="{ primary, secondary, event, danger }"
                style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";

export default {
  name: "AddCompanyMembers",
  components: {
    ActionButton
  },
  data() {
    return {
      members: [
        "Zaff Fadington",
        "Archer Nox",
        "Theodor Fade",
        "Omen Kobe",
        "Jinx Hunt",
        "Holstein Skinner",
        "Scias Willow",
        "Jayden Shackleton",
        "Abraham Interfector"
      ],
      addedMembers: [],
      selectedMember: null
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    handleAddMemberClick() {
      if (this.selectedMember !== null) {
        this.addedMembers.push(this.selectedMember);
        this.members.find((e, i) => {
          if (e === this.selectedMember) {
            this.members.splice(i, 1);
          }
        });
        this.selectedMember = null;
      }
    },
    handleMemberRemoveClick(params) {
      const { index } = params;
      this.addedMembers.find((e, i) => {
        if (index === i) {
          this.members.push(e);
          this.addedMembers.splice(i, 1);
        }
      });
    }
  }
};
</script>

<style lang="scss"></style>
